import { Outlet, Link, useLocation } from 'react-router-dom'

export default function Layout() {
  const location = useLocation()
  const isAmbassadorRoute = location.pathname.startsWith('/ambassador')

  return (
    <div className="min-h-screen bg-gray-50">
      <header className={`${isAmbassadorRoute ? 'bg-sla-blue' : 'bg-sla-green'} text-white shadow-md`}>
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/images/logo.png"
              alt="School Lunch Angels"
              className="h-12 w-auto"
            />
            <div className="text-2xl font-bold">School Lunch Angels</div>
          </Link>
          <p className={`${isAmbassadorRoute ? 'text-blue-200' : 'text-green-200'} text-sm mt-1`}>
            Helping students focus on learning without worry.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <Outlet />
      </main>

      <footer className="bg-gray-800 text-gray-300 py-8 mt-auto">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} School Lunch Angels. All rights
            reserved.
          </p>
          <p className="text-xs mt-2 text-gray-500">
            School Lunch Angels is a 501(c)(3) tax-exempt organization.
          </p>
        </div>
      </footer>
    </div>
  )
}
